import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import JsonData from "../data/data.json";

export const About = () => {
  const { t } = useTranslation("landing");
  const aboutRef = useRef(null);
  const brand = JsonData?.About?.nameBank || "COFISA";
  const paragraphs = t("about.paragraphs", { returnObjects: true });
  const why = t("about.why", { returnObjects: true });
  const why2 = t("about.why2", { returnObjects: true });

  useEffect(() => {
    const currentAbout = aboutRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (currentAbout) {
      observer.observe(currentAbout);
    }

    return () => {
      if (currentAbout) {
        observer.unobserve(currentAbout);
      }
    };
  }, []);

  return (
    <div id="about" ref={aboutRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>{t("about.title", { brand })}</h2>

              {Array.isArray(paragraphs)
                ? paragraphs.map((paragraph, index) => (
                    <p className="paragraph" key={index}>
                      {paragraph}
                    </p>
                  ))
                : (
                  <p className="paragraph">{t("about.loading")}</p>
                )}

              <h3>{t("about.whyHeading")}</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {Array.isArray(why)
                      ? why.map((item, i) => <li key={`${item}-${i}`}>{item}</li>)
                      : t("about.loading")}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {Array.isArray(why2)
                      ? why2.map((item, i) => <li key={`${item}-${i}`}>{item}</li>)
                      : t("about.loading")}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 d-flex">
            <img src="img/bout.png" className="img-responsive" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
